import React from "react";
const ChartIq = (props) => {
    return (
    // <iframe
    //   className={`iframeClass ${props.parentClass}`}
    //   id="chartiq"
    //   src={`https://www.nuvamawealth.com/chartiq/index.html?sym=${props?.symbol}&type=quote1&src=web`}
    // ></iframe>
    React.createElement("embed", { className: `graph-chart ${props.parentClass}`, src: `https://vamauat.nuvamawealth.com/tradingview/?instru=${props === null || props === void 0 ? void 0 : props.instru}&sym=${props === null || props === void 0 ? void 0 : props.symbol}&chttype=snap`, id: "chartiq", type: "text/html" }));
};
export default ChartIq;
